import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import Cell from "source/app/presentation/MainPanel/Dreams/Cell/Cell";
import { UpDownDifficultySelector } from "source/app/presentation/MainPanel/Dreams/Controls/Difficulty/UpDownSelector/UpDownDifficultySelector";
import { Sounds } from "source/app/services/Sound/Sounds";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { DreamInfoIcons } from "source/app/presentation/MainPanel/Dreams/InfoIcon/DreamInfoIcons";
import { dreamService } from "motw_core/Services/DreamService";
import { DreamReviewIcon } from "source/app/presentation/MainPanel/Dreams/Controls/Difficulty/ReviewIcon/DreamReviewIcon";

export function DreamControls({
    dream,
    showSelector,
    setShowSelector,
    onDifficultyChanged,
    hideDifficultyArrows = false,
}: {
    dream: IDream;
    showSelector: boolean;
    setShowSelector: React.Dispatch<React.SetStateAction<boolean>>;
    onDifficultyChanged: () => void;
    hideDifficultyArrows?: boolean;
}) {
    function ToggleQuickSelector() {
        const sound = showSelector ? Sounds.wooden_thump : Sounds.wooden_creak;
        sound.Play();
        setShowSelector(!showSelector);
    }

    return (
        <span
            style={{
                display: `inline-flex`,
                alignItems: `center`,
                flexWrap: `nowrap`,
                gap: `2px`,
                whiteSpace: `nowrap`,
            }}
        >
            <span
                style={{
                    display: `inline-flex`,
                    alignItems: `center`,
                    flexWrap: `nowrap`,
                    gap: `2px`,
                    whiteSpace: `nowrap`,
                    opacity: 0.9,
                }}
            >
                <DreamInfoIcons
                    dream={dream}
                    isShowingQuickSelector={showSelector}
                />
                <DreamReviewIcon {...{ dream }} />
            </span>
            <Cell style={{ margin: 0 }}>
                <UpDownDifficultySelector
                    {...{
                        dream,
                        ToggleQuickSelector,
                        onDifficultyChanged,
                        hideDifficultyArrows,
                    }}
                />
            </Cell>
        </span>
    );
}

export function CanDreamBeRemoved(dream: IDream) {
    const canDecisionDreamBeRemoved =
        dreamService.DoesDreamHaveAttribute(dream, EDA.decision) &&
        (dream.difficulty <= 1 || dream.difficulty >= 11);

    const canProblemDreamBeRemoved =
        dreamService.DoesDreamHaveAttribute(dream, EDA.problem) &&
        dream.difficulty < 5;

    return canDecisionDreamBeRemoved || canProblemDreamBeRemoved;
}
